<div class="ui-invoices">
    <div class="ui-invoices-header" *ngIf="invoicesInitStatus">
        <div class="ui-invoices-header-container">
            <div class="ui-invoices-header-amount">
                <h1><small>$</small> {{user.balance.total}}</h1>  
                <span *ngIf="user.balance.status">Balance de la cuenta</span>
                <span *ngIf="!user.balance.status">Total pendiente de pago</span>
            </div>

            <button mat-flat-button color="primary" class="ui-button" (click)="onPaymentAll()" *ngIf="!user.balance.status && user.isPaymentStatus()">Realizar pago total</button>  
        </div>
    </div>
    
    <div class="ui-invoices-list" [hidden]="!invoicesInitStatus">
        <div class="ui-invoices-list-container">
            <div class="ui-bar-filters">
                <div class="el-left-filters">
                    <button mat-flat-button class="ui-button" [matMenuTriggerFor]="filterType">Tipo<i *ngIf="filters.type != ''">: {{filtersData('type', filters.type)}}</i> <mat-icon>expand_more</mat-icon></button> 
                    
                    <!--<mat-menu #filterType="matMenu">
                        <button mat-menu-item (click)="onFilterSelect('type', '')">Todo</button>
                        <button mat-menu-item (click)="onFilterSelect('type', 'Factura')">Factura</button>
                        <button mat-menu-item (click)="onFilterSelect('type', 'Credito')">Nota de crédito</button>
                        <button mat-menu-item (click)="onFilterSelect('type', 'Debito')">Nota de débito</button>
                    </mat-menu>-->

                    <mat-menu #filterType="matMenu">
                        <button mat-menu-item (click)="onFilterSelect('type', '')">Todo</button>
                        <button mat-menu-item (click)="onFilterSelect('type', item.name)" *ngFor="let item of filterInvoiceTypes; last as last">{{item.name}}</button>
                    </mat-menu>
                     
                    <button mat-flat-button class="ui-button" [matMenuTriggerFor]="filterStatus">Estado<i *ngIf="filters.status != ''">: {{filtersData('status', filters.status)}}</i> <mat-icon>expand_more</mat-icon></button>

                    <mat-menu #filterStatus="matMenu">
                        <button mat-menu-item (click)="onFilterSelect('status', '')">Todo</button>
                        <button mat-menu-item (click)="onFilterSelect('status', item.name)" *ngFor="let item of filterInvoiceStatus; last as last">{{item.name}}</button>
                    </mat-menu>
                    
                    <mat-form-field class="date-multiple" >
                        <mat-label>Fecha de emisión</mat-label>
                        <mat-date-range-input [rangePicker]="filterDate" >
                            <input matStartDate placeholder="Desde" (focus)="filterDate.open()" [(ngModel)]="filters.date.start">
                            <input matEndDate placeholder="Hasta" (focus)="filterDate.open()" [(ngModel)]="filters.date.end" (dateChange)="onFilterSelect('date')">
                        </mat-date-range-input>
                        <button matSuffix mat-flat-button (click)="onFilterSelect('date', '')" *ngIf="filters.date.end != '' && filters.date.end != null"><mat-icon>close</mat-icon></button>
                        <mat-date-range-picker #filterDate></mat-date-range-picker>
                    </mat-form-field>
                    
                    <mat-form-field class="date-multiple">
                        <mat-label>Fecha de vencimiento</mat-label>
                        <mat-date-range-input [rangePicker]="filterDateExpiration">
                            <input matStartDate placeholder="Desde" (focus)="filterDateExpiration.open()" [(ngModel)]="filters.dateExpiration.start">
                            <input matEndDate placeholder="Hasta" (focus)="filterDateExpiration.open()" [(ngModel)]="filters.dateExpiration.end" (dateChange)="onFilterSelect('dateExpiration')">
                        </mat-date-range-input>
                        <button matSuffix mat-flat-button (click)="onFilterSelect('dateExpiration', '')" *ngIf="filters.dateExpiration.end != '' && filters.dateExpiration.end != null"><mat-icon>close</mat-icon></button>
                        <mat-date-range-picker #filterDateExpiration></mat-date-range-picker>
                    </mat-form-field>
                </div>

                <div class="el-right-filters">
                    <button mat-flat-button class="ui-button" [matMenuTriggerFor]="filterExport">Exportar listado <mat-icon>expand_more</mat-icon></button>
    
                    <mat-menu #filterExport="matMenu">
                        <button mat-menu-item (click)="onExport('xls')">Microsoft Excel (xlsx)</button>
                        <button mat-menu-item (click)="onExport('cvs')">CVS separado por coma (cvs)</button>
                        <button mat-menu-item (click)="onExport('json')">Archivo JSON (json)</button>
                    </mat-menu>
                </div>
            </div>
            
            <div class="ui-shadow" style="position:relative;">
                <div class="ui-spinner-container" *ngIf="invoicesUpdating">
                    <mat-spinner class="ui-spinner" [diameter]="25"></mat-spinner>
                </div>

                <div class="invoice" *ngIf="invoices.length <= 0"><div class="invoice-empty">No existen facturas para mostrar</div></div>

                <div class="invoice" [ngClass]="{'invoice-pending': invoice.status == 'Impaga'}" *ngFor="let invoice of invoices; last as last">
                    <div class="invoice-status">
                        <mat-checkbox class="example-margin" color="primary" [(ngModel)]="invoicesSelected[invoice.id]" value="invoice.status" *ngIf="invoice.isPayable() && user.isPaymentStatus()" (change)="onInvoicesSelected()"></mat-checkbox>                        
                        <mat-icon *ngIf="!invoice.isPayable()" [ngClass]="{'ui-success': invoice.status == 'Paga', 'ui-pending': (invoice.status == 'Parcial' || invoice.status == 'Pendiente')}" [matTooltip]="invoice.status">lens</mat-icon>
                    </div>
                    
                    <div class="invoice-type">
                        <div>{{invoice.typeShort}}</div>
                    </div>

                    <div class="invoice-data">                        
                        <div class="invoice-data-content">
                            <div class="invoice-receipt">
                                {{invoice.receipt}}
                                
                                <button mat-icon-button [routerLink]="[invoice.id, invoice.type, 'llamadas']" *ngIf="invoice.isCalls">
                                    <mat-icon>phone</mat-icon>
                                </button>
                            </div>
                            <span class="invoice-date">Emitida el {{invoice.date | date: 'dd/MM/yyyy'}}</span>                            
                        </div>
                        
                        <div class="invoice-date-expiration"  *ngIf="invoice.status == 'Impaga'" matTooltip="Fecha de vencimiento">
                            <span>Vencimiento</span> {{invoice.dateExpiration | date: 'dd/MM/yyyy'}}                            
                        </div>
                    </div>

                    <div class="invoice-amount">
                        <small>$</small> {{invoice.total | number:'1.2-2'}}
                        <span class="invoice-balance" *ngIf="invoice.status == 'Impaga'" matTooltip="Saldo pendiente"><small>$</small> {{invoice.balance | number:'1.2-2'}}</span>
                    </div>

                    <div class="invoice-options">
                        <button mat-icon-button [matMenuTriggerFor]="invoiceMenu">
                            <mat-icon>more_vert</mat-icon>
                        </button>                        
                        <mat-menu #invoiceMenu="matMenu">
                            <button mat-menu-item (click)="onPay(invoice)" *ngIf="invoice.status == 'Impaga' && user.isPaymentStatus()">Pagar esta factura</button>
                            <button mat-menu-item [routerLink]="[invoice.id, invoice.type, 'llamadas']" *ngIf="invoice.isCalls">Ver listado de llamadas</button>
                            <button mat-menu-item (click)="onDownload(invoice)">Descargar factura</button>
                            <button mat-menu-item (click)="onEmailSend(invoice)">Enviar por email</button>
                        </mat-menu>
                    </div>
                </div>

                <mat-paginator *ngIf="invoices.length > 0" [length]="invoicesTotal" [pageSize]="invoicesPageSize" [pageSizeOptions]="[10, 20, 50, 100]" (page)="onPaginationChange($event)"></mat-paginator>
            </div>

            <div class="ui-invoices-list-footer" *ngIf="invoicesSelectedAmount != '' && user.isPaymentStatus()">
                <div class="ui-invoices-list-footer-amount">
                    <span>Total a pagar</span>
                    <h1><small>$</small> {{invoicesSelectedAmount}}</h1>                    
                </div>
               
                <div class="ui-invoices-list-footer-actions">
                    <button mat-raised-button color="primary" class="ui-button" (click)="onPay()">Realizar pago</button>
                </div>
            </div>
        </div>
    </div>

    <ui-screen-loader *ngIf="!invoicesInitStatus"></ui-screen-loader>
</div>